// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"388":"fb5f3d9f","390":"eb90f606","707":"7355a187","773":"0cf5822d","776":"720bf125"}[chunkId] + ".chunk.js";
};